export { AuthApiError, AuthError } from "@supabase/supabase-js"

import { PostgrestError } from "@supabase/supabase-js"

export { PostgrestError }

export class AuthenticationError extends Error {
  constructor() {
    super("Authentication required")
  }
}

/**
 * Type guard to check if an error is a PostgrestError with a specific error code.
 * Uses error.code instead of instanceof because errors may lose their prototype
 * chain when crossing module boundaries or being serialized.
 */
export function isPostgrestErrorWithCode(
  error: unknown,
  code: string,
): error is PostgrestError {
  return (
    error !== null &&
    typeof error === "object" &&
    "code" in error &&
    typeof error.code === "string" &&
    error.code === code
  )
}
